<template>
    <div>
        <va-card v-if="pagamento == true" class="flex xs12 sm12 lg12" >
        <div class="mb-3">
            <va-notification color="primary" closeable>
             
              {{$t('arealuno.mensagem_sucesso')}}
            </va-notification>
          </div>
        </va-card>

         <va-card v-if="pagamento == false" class="flex xs12 sm12 lg12" >
         <div class="mb-3">
            <va-notification color="danger" closeable>
             
              {{$t('arealuno.mensagem_fail')}}
            </va-notification>
          </div>
        </va-card>
  
  </div>

</template>


<script>

import axios from 'axios';
export default {
    name:'confirm',

    data () {
        return {

          pagamento:'',
           
     
        }

    },

     created(){
      var url_string = window.location.href;
      //var url = new URL(url_string);
      var parametrosDaUrl = url_string.split("?")[1]; // id=10&name=gustavo
      var listaDeParametros = parametrosDaUrl.split("=") 
    
      let resultado = url_string.split("=")
      console.log(resultado[1])
      let pag = resultado[1]

        if(pag == "payment_fail"){
            this.pagamento = false
        }

        if(pag == "payment_success"){
            this.pagamento = true
        }

    },

   
    methods:{

    }
    
}
</script>

<style lang="scss" scoped>



</style>